import React from 'react';
export function HeroSection() {
  return <section className="relative pt-6 pb-0 md:pt-28 overflow-hidden bg-[#F1F4F8]" data-id="element-98">
      {/* Glow */}
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[700px] h-[450px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(45,149,150,0.22) 0%, transparent 70%)'
    }} data-id="element-99" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-100">
        {/* Brand */}
        <div className="animate-fade-in-up inline-flex items-center gap-2 px-3 py-1 sm:px-5 sm:py-2 rounded-full bg-white border border-[#D5DCE5] text-[#1E3A5F] text-[9px] sm:text-xs font-bold tracking-[0.2em] mb-4 sm:mb-8 shadow-sm uppercase" data-id="element-101">
          <span className="w-1.5 h-1.5 rounded-full bg-[#2D9596] animate-pulse" data-id="element-102" />
          Kit Anticontracturas · Oficina™
        </div>

        {/* Headline (promise) */}
        <h1 className="animate-fade-in-up delay-100 text-[26px] leading-[1.1] sm:text-5xl md:text-7xl text-[#1A2433] sm:leading-[1.05] tracking-tight mb-3 sm:mb-6" data-id="element-103">
          El sistema N°1 para eliminar el dolor de cuello, espalda y hombros
          <br className="hidden sm:block" data-id="element-104" />
          <span className="italic text-[#1E3A5F]" data-id="element-105"> en solo 7 DÍAS</span>
        </h1>

        {/* Product Mockup */}
        <div className="animate-fade-in-up delay-200 flex justify-center mb-3 sm:mb-6" data-id="element-106">
          <img src="https://cdn.magicpatterns.com/uploads/sH8YeNdp883eusQmnwgF7z/MOCKUP_KIT_ANTICONTRACTURA_.png" alt="Kit Anticontracturas Para Oficina — El kit más completo para oficinistas" className="w-full max-w-[280px] sm:max-w-lg drop-shadow-2xl" loading="eager" decoding="async"
        // @ts-ignore - fetchPriority is a valid HTML attribute
        fetchpriority="high" width={1024} height={1024} data-id="element-107" />
        </div>

        {/* Subtitle */}
        <p className="animate-fade-in-up delay-250 text-xs sm:text-base md:text-lg text-[#4A5568] max-w-2xl mx-auto leading-relaxed mb-5 sm:mb-10 px-2" data-id="element-108">
          Diagnóstico + Liberación + Ergonomía + Plan 21 Días + Sueño +
          Alimentación + Tracker + PRO.
        </p>

        {/* Product Card — collapsed to feature row on mobile, full card on desktop */}
        <div className="animate-fade-in-up delay-300 hidden md:block bg-white border border-[#D5DCE5] rounded-2xl p-4 sm:p-6 md:p-10 mb-6 relative overflow-hidden shadow-lg" data-id="element-109">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2D9596] via-[#5BB5B5] to-[#2D9596]" data-id="element-110" />
          <div className="text-[10px] tracking-[0.25em] text-[#2D9596] font-bold uppercase mb-2 sm:mb-3" data-id="element-111">
            Sistema Digital 2025
          </div>
          <h2 className="text-xl sm:text-2xl md:text-4xl text-[#1A2433] mb-3 sm:mb-4 leading-tight" data-id="element-112">
            Kit Anticontracturas <span className="italic" data-id="element-113">Para Oficina</span>™
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#1E3A5F] font-medium mb-3 sm:mb-5 italic" data-id="element-114">
            Diagnóstico + Liberación + Ergonomía + Plan 21 Días + Sueño +
            Alimentación + Tracker + PRO
          </p>
          <p className="text-[#4A5568] text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-115">
            Protocolos + ejercicios + setup ergonómico + alimentación
            anti-inflamatoria + fortalecimiento muscular listos para implementar
            hoy.
          </p>
        </div>

        {/* CTA */}
        <div className="animate-fade-in-up delay-350 flex flex-col items-center mb-5 sm:mb-10" data-id="element-116">
          <a href="#pricing" className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-6 sm:px-12 py-3.5 sm:py-5 text-sm sm:text-base md:text-lg font-bold text-white hover:bg-[#268485] rounded-full transition-all active:scale-95 shadow-xl tracking-wider uppercase bg-[#2D9596]" data-id="element-117">
            → Quiero mi Kit ahora
          </a>
          <div className="flex flex-wrap justify-center items-center gap-1.5 sm:gap-3 md:gap-4 mt-3 sm:mt-6 text-[10px] sm:text-xs md:text-sm font-medium text-[#4A5568]" data-id="element-118">
            <span data-id="element-119">🛡️ Garantía 30 días</span>
            <span className="hidden sm:inline text-[#D5DCE5]" data-id="element-120">|</span>
            <span data-id="element-121">🔒 Pago seguro</span>
            <span className="hidden sm:inline text-[#D5DCE5]" data-id="element-122">|</span>
            <span data-id="element-123">💳 Mercado Pago</span>
          </div>
        </div>

        {/* Badges */}
        <div className="animate-fade-in-up delay-400 flex flex-wrap justify-center gap-1 sm:gap-2 md:gap-3 mb-6 sm:mb-16" data-id="element-124">
          {['📄 100% PDF', '⚡ Acceso 5 min', '🇦🇷 Argentina', '📚 4 Tomos + 4 Bonos', '🔒 Pago seguro'].map((b, i) => <span key={i} className="px-2 py-0.5 sm:px-3 sm:py-1.5 md:px-4 md:py-2 rounded-full bg-[#E8EDF3] text-[#4A5568] text-[9px] sm:text-xs md:text-sm font-medium border border-[#D5DCE5]" data-id="element-125">
              {b}
            </span>)}
        </div>
      </div>

      {/* Stats Bar */}
      <div className="animate-fade-in delay-600 border-y border-[#D5DCE5] bg-white/70 backdrop-blur-sm" data-id="element-126">
        <div className="max-w-5xl mx-auto px-4" data-id="element-127">
          <div className="grid grid-cols-4 gap-y-3 sm:gap-y-6 py-4 sm:py-8 md:py-10" data-id="element-128">
            {[{
            val: '+800',
            label: 'oficinistas'
          }, {
            val: '4',
            label: 'Tomos'
          }, {
            val: '4',
            label: 'Bonos'
          }, {
            val: '4.9 ★',
            label: 'rating'
          }].map((s, i) => <div key={i} className="text-center px-1 sm:px-4" data-id="element-129">
                <div className="text-lg sm:text-3xl md:text-5xl text-[#1A2433] mb-0.5 sm:mb-1 font-semibold" data-id="element-130">
                  {s.val}
                </div>
                <div className="text-[8px] sm:text-[10px] md:text-xs text-[#4A5568] font-medium uppercase tracking-[0.12em] sm:tracking-[0.18em]" data-id="element-131">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}